import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    makeRequest,
    dispatchAction,
    displayMessage
} from 'actions';
import {
    Row,
    Col,
    Form,
    InputGroup,
    FormGroup,
    Checkbox,
    Modal,
    ControlLabel,
    FormControl,
    Button
} from 'react-bootstrap';

import {handleFrameTasks, sendDataForIframe}  from 'shared/sharedMethods';


import queryString from 'query-string'
import PaginationBox from'shared/PaginationBox';
import {prepareSelectOptionsList} from 'util/Utils';

import {validateEmail}  from 'util/Utils';
import UserFavoritesListTable from "./UserFavoritesListTable";
import {v4 as uuidv4}  from 'uuid'
class UserFavoritesPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }


    constructor(props, context) {
        super(props, context);
        this.state = {
            pending: true,
            userData:{},
            records: 'dataNotReceived',
             perPage: 10,
            ShopifyCustomerID: _.get(this.props, ['location', 'query', 'customerid'], false),
        };

    };

    componentWillMount() {
        this.search()
        if (_.get(this.props, ['location', 'query', 'userID'], false)){
            this.getUserData(_.get(this.props, ['location', 'query', 'userID'], false))
    }
    }

    componentDidMount() {
        window.addEventListener("message", this.handleFrameTasks.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.handleFrameTasks);
    }
    getUserData(ShopifyCustomerID) {
        var methodData = {
            'endpoint': '/get-user-data-with-query',
             'type': 'post',
        };
        return this.props.makeRequest({fieldsToInclude:['User'], ShopifyCustomerID: ShopifyCustomerID}, methodData).then(res => {

            this.setState({userData:_.get(res.data, 'User')})
        })
    }
    handleFrameTasks(event) {
         handleFrameTasks.call(this, {
            displayMessage: this.props.displayMessage,
            event: event,
            elementID: 'subscriptionsList'
        })
    }

    onSortChange(field, sortOrder) {
        console.log('field', field);
        this.setState({sortBy: field + ':' + (sortOrder == 'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }


    search( ) {

        var self = this;
        var queryParams = {}
        if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
        } else {
            queryParams.sortBy = 'Type' + ':' + 1;
        }
        // queryParams.all=true;
        var recorIDs = _.get(this.props, ['location', 'query', 'recordIDs'], '').split(',')
     if(recorIDs[0] ==''){

            setTimeout(function() {
                self.props.displayMessage({
                    type:'warning',
                    'messageCode': 'Sorry,  link is not valid'
                });
            }, 1000)

         return
     }
            queryParams.recordIDs = recorIDs

      queryParams.sortBySecondary = '_id:-1';
        /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */
     ///  queryParams.checkUserEmail = true;
        queryParams.perPage = 10
    //    queryParams.Deleted = false
     //   queryParams.Types = ['PriceDrop', 'InStock', 'Favorites']
        //    queryParams.Types =  [   'Favorites']
      //  queryParams.UserID = this.props.userReducer.user._id;
        var methodData = {
            "endpoint": "/search-subscriptions",
            'not_display_success_message': true,
        };
        return this.props.makeRequest(queryParams, methodData).then(res => {
            if (this.refs.pagination && _.isUndefined(queryParams.page)) {
                this.refs.pagination.resetPagination();
            }

            // if (_.get(this.props, ['location', 'query', 'customerid'], false)){
            //     var userDataFound = {}
            // }else {
            //    var userDataFound = _.find(res.data.data, item => {
            //         return _.get(item, 'User.firstName')
            //     })
            // }


                this.setState( {  records: res.data.data, pending: false, recordsTotal: res.data.total})
            sendDataForIframe.call(this, 'subscriptionsList')
        }).catch(err => {
            console.log('err', err);
            this.setState({pending: false})
            sendDataForIframe.call(this, 'subscriptionsList')
        });
    }


    render() {
        console.log(' user favorites this state', this.state );

        return (
            <div >
                <div>

                    {(this.state.records !== 'dataNotReceived' ) &&
                    <div>
                        <div style={{ margin:'0 auto', width:208,  padding:'7px  0px 43px'}}>
                            <a href="https://goodbuygear.com">
                                <img style={{display:'block'}} width="208" height="112"
                                     src="https://s3-us-west-2.amazonaws.com/gbg1/common/GBG-logo-email.png"/>
                            </a>
                        </div>
                        <div className="font-size-20 bot25 pleft10 pright10">
                            {_.get(this.state,'userData.firstName')&&
                            <div className="pbot5"> Lucky you!  {_.get(this.state,'userData.firstName')  + ' ' +_.get(this.state,'userData.lastName')} thinks you should be in the loop on the
                                #goodbuys she is eyeing.</div>
                            }
                            <div className="pbot5">GoodBuy Gear is an online marketplace for buying and selling gently used kid stuff. </div>
                            <div className="pbot5">We provide a safe, convenient, and affordable option for stocking up on all the essentials needed for raising a kid.</div>
                            {_.get(this.state, 'userData.firstName') &&
                            <div> Here are the items {_.get(this.state,'userData.firstName')  + ' ' +_.get(this.state,'userData.lastName')}  is wishing for:</div>
                            }
                        </div>
                        {this.state.recordsTotal == 0 ?
                            <div
                                className="messageBox">{'No records found.'}</div> :
                            <div className="top20" ref={ page => {
                                if (page && !this.pageContent) {
                                    this.pageContent = page;
                                    sendDataForIframe.call(this, 'subscriptionsList')
                                }
                            }}>



                                <UserFavoritesListTable
                                    ref={'table'}
                                    onSortChange={this.onSortChange.bind(this)}

                                    records={this.state.records}
                                    search={this.search.bind(this)} {...this.props}  ></UserFavoritesListTable>
                                <PaginationBox
                                    doNotDisplayPageDataBlock={true}
                                    currentPage={_.isUndefined(queryString.parse(this.props.location.search).page) ? 0 : parseInt(queryString.parse(this.props.location.search).page) - 1}
                                    perPage={ this.state.perPage}
                                    ref={'pagination'}
                                    total={this.state.recordsTotal}
                                    search={this.search.bind(this)}>
                                </PaginationBox>
                                <div className="clearfix  pbot20"></div>
                            </div>}

                    </div>
                    }
                </div>
                {this.state.pending &&
                <div className="pending-box"></div>
                }
            </div >
        );

    }
}

function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UserFavoritesPage);
